module.exports = __webpack_public_path__ + "3213f4be58d650349002037a7aee159d.jpg";